export default __webpack_public_path__ + "static/media/muromets.8ca6b877.png";